import React, { Component } from 'react';
import { Footer } from '../Components/Footer';
import { Link } from 'react-router-dom';
import { formatDate } from '../utils/utils';
import TitleCard from '../Components/TitleCard.js';
import { ChevronRight } from 'lucide-react';
import NewsletterSignup from '../Components/NewsletterSignup';

let id = null;

class ArticleDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            articleDetails: null,
            loading: false,
            name: '',
            email: '',
        };
        id = window.location.href.split('/')[4];
    }

    componentDidMount() {
        id = window.location.href.split('/')[4];
        this.getArticle(id);
    }

    componentWillUnmount() {
    }

    getArticle(id) {
        this.setState({ loading: true });
        const useMock = false;

        if (useMock) {
            // Mock de um artigo detalhado
            const mockArticle = {
                id,
                imagem: '/images/blog/example.svg',
                alt: 'Exemplo de artigo',
                titulo: 'Como interpretar os principais indicadores fiscais do país',
                resumo: 'Entenda como a tecnologia influencia a eficiência e transparência na gestão dos recursos públicos',
                conteudo: `
                    <p>
                        <strong>Conteúdo detalhado do artigo mock para testes.</strong>
                        Texto em <em>HTML</em>.
                    </p>
                    <ul>
                        <li><b>Automatização</b> e <span style="color:blue;">Redução de Custos</span></li>
                        <li><i>Transparência</i> e <u>Controle Social</u></li>
                        <li><mark>Big Data</mark> e <code>Inteligência Artificial</code></li>
                        <li><span style="font-size:18px;">Blockchain</span> e <span style="background:yellow;">Segurança dos Dados</span></li>
                        <li><a href="https://exemplo.com">Exemplos de Sucesso</a></li>
                        <li><strong>Conclusão</strong></li>
                    </ul>
                    <blockquote>
                        "A tecnologia é fundamental para a evolução da gestão fiscal."
                    </blockquote>
                    <p>
                        <img src="/images/blog/example.svg" alt="Exemplo" width="200" />
                    </p>
                `,
                // conteudo: 'texto normal',
                topicos: [
                    'Automatização e Redução de Custos',
                    'Transparência e Controle Social',
                    'Big Data e Inteligência Artificial',
                    'Blockchain e Segurança dos Dados',
                    'Exemplos de Sucesso',
                    'Conclusão'
                ],
                autor: 'João Silva',
                data_publicacao: '2024-05-10',
            };
            setTimeout(() => {
                this.setState({ articleDetails: mockArticle, loading: false });
            }, 800);
        } else {
            fetch(process.env.REACT_APP_API_URL + `/postagens/${id}/`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                }
            }).then(resp => resp.json())
                .then(resp => {
                    if (resp && resp.detail !== "Não encontrado.") {
                        this.setState({ articleDetails: resp, loading: false });
                    } else {
                        this.setState({ articleDetails: null, loading: false });
                    }
                }).catch(err => {
                    console.log(err);
                    this.setState({ articleDetails: null, loading: false });
                })
        }
    }

    getCategoryIconSrc = (categoria) => {
        switch (categoria) {
            case 'ANÁLISES':
                return '/images/icons/chart.svg';
            case 'ECONOMIA':
                return '/images/icons/diagram_up.svg';
            case 'ESTUDOS TÉCNICOS':
                return '/images/icons/clipboard_text.svg';
            case 'TENDÊNCIAS':
                return '/images/icons/chat_square_check.svg';
            case 'TRANSPARÊNCIA':
                return '/images/icons/round_graph.svg';
            default:
                return '/images/icons/Buildings.svg';
        }
    };

    render() {
        const { articleDetails, name, email, loading } = this.state;
        const isMobile = window.innerWidth <= 767;

        return (
            <div className='container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div className='article-div'>
                    {loading ? (
                        <div
                            style={{
                                height: '350px',
                                minWidth: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: '#F8F9FB',
                                border: '1px solid #E0E0E0',
                                borderRadius: '18px',
                                margin: '40px 0'
                            }}
                        >
                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                                <circle cx="24" cy="24" r="20" stroke="#37428E" strokeWidth="4" opacity="0.2" />
                                <circle cx="24" cy="24" r="20" stroke="#37428E" strokeWidth="4" strokeDasharray="100" strokeDashoffset="60">
                                    <animateTransform attributeName="transform" type="rotate" from="0 24 24" to="360 24 24" dur="1s" repeatCount="indefinite" />
                                </circle>
                            </svg>
                            <span style={{ marginTop: '18px', fontSize: '20px', color: '#37428E', fontWeight: 500 }}>Carregando artigo...</span>
                        </div>
                    ) : (
                        articleDetails ?
                            <div className='article-img-block mt-5'>
                                <div style={{ width: '100%' }}>
                                    <div style={{ marginBottom: '30px' }}>
                                        <img
                                            src="/images/icons/home.svg"
                                            width="18"
                                            alt="Home"
                                        />
                                        <Link to="/" style={{ color: '#818181', fontSize: '14px', marginLeft: '10px', textDecoration: 'none' }}>
                                            Início
                                        </Link>
                                        <ChevronRight style={{ width: '18px', color: '#818181', marginLeft: '5px' }} />

                                        <Link to="/article" style={{ color: '#818181', fontSize: '14px', marginLeft: '10px', textDecoration: 'none' }}>
                                            Artigos
                                        </Link>

                                        <ChevronRight style={{ width: '18px', color: '#818181', marginLeft: '5px' }} />

                                        <span style={{ color: '#818181', fontSize: '14px', marginLeft: '10px', textDecoration: 'none' }}>Análises</span>

                                        <ChevronRight style={{ width: '18px', color: '#818181', marginLeft: '5px' }} />

                                        <span style={{ color: '#4654A3', fontSize: '14px', marginLeft: '5px' }}>{articleDetails.titulo}</span>
                                    </div>
                                    <TitleCard
                                        iconLeft={<img
                                            src={this.getCategoryIconSrc(articleDetails.categoria)}
                                            width="18"
                                            alt={articleDetails.categoria ? articleDetails.categoria : 'OUTROS'}
                                        />}
                                        label={articleDetails.categoria ? articleDetails.categoria : 'OUTROS'}
                                    />
                                    <div>
                                        <span className='article-detail-title mt-2'>{articleDetails.titulo}</span>
                                        <span className='article-detail-content mt-1'>
                                            {/<[a-z][\s\S]*>/i.test(articleDetails.resumo)
                                                ? (
                                                    <span
                                                        className='article-detail-content mt-3'
                                                        dangerouslySetInnerHTML={{ __html: articleDetails.resumo }}
                                                    />
                                                )
                                                : (
                                                    <span className='article-detail-content mt-3'>
                                                        {articleDetails.resumo}
                                                    </span>
                                                )
                                            }
                                        </span>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '30px', marginTop: '20px' }}>
                                            <div>
                                                <img
                                                    src="/images/blog/user.svg"
                                                    width="20"
                                                    alt="Autor"
                                                />
                                                <span style={{ fontSize: '14px', color: '#818181', marginLeft: '5px' }}>{articleDetails.autor}</span>
                                            </div>

                                            <div>
                                                <img
                                                    src="/images/blog/calendar.svg"
                                                    width="20"
                                                    alt="Data"
                                                />
                                                <span style={{ fontSize: '14px', color: '#818181', marginLeft: '5px' }}>
                                                    {formatDate(articleDetails.data_publicacao)}
                                                </span>
                                            </div>

                                        </div>
                                    </div>

                                </div>


                                <img
                                    src={articleDetails.imagem}                                    
                                    // height="120"
                                    // className="d-inline-block align-top article-image"
                                    alt={articleDetails.titulo}
                                    style={{ maxHeight: isMobile ? '180px' : 'auto', maxWidth: isMobile ? 'min(100%, 767px)' : 'min(100%, 1140px)', minWidth: isMobile ? '317px' : '800px', borderRadius: '30px', marginBottom: '20px' }}

                                />
                                <div className='article-outer-text-block'>
                                    <div className='article-text-block'>
                                        {/<[a-z][\s\S]*>/i.test(articleDetails.conteudo)
                                            ? (
                                                <span
                                                    className='article-detail-content mt-3'
                                                    dangerouslySetInnerHTML={{ __html: articleDetails.conteudo }}
                                                />
                                            )
                                            : (
                                                <span className='article-detail-content mt-3'>
                                                    {articleDetails.conteudo}
                                                </span>
                                            )
                                        }
                                    </div>
                                    {false && Array.isArray(articleDetails.topicos) && articleDetails.topicos.length > 0 && (
                                        <div style={{ display: 'flex', height: '100%' }}>
                                            <div style={{ borderLeft: '2px solid #F0F0F0', height: '80%', width: '1px', marginTop: '10px', marginBottom: '10px' }}></div>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', padding: '20px', width: '40%' }}>
                                                <span className='topic-title mt-5 mb-1'>Navegue pelo conteúdo</span>
                                                {articleDetails.topicos.map((topico, idx) => (
                                                    <span key={idx} className='article-title-min mt-2'>{topico}</span>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>

                            </div>
                            :
                            <div
                                style={{
                                    height: '350px',
                                    minWidth: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: '#F8F9FB',
                                    border: '1px solid #E0E0E0',
                                    borderRadius: '18px',
                                    margin: '40px 0'
                                }}
                            >
                                <svg width="64" height="64" viewBox="0 0 48 48" fill="none">
                                    <rect x="8" y="12" width="32" height="24" rx="4" fill="#F0F0F0" />
                                    <path d="M16 20H32M16 26H32" stroke="#818181" strokeWidth="2" strokeLinecap="round" />
                                    <circle cx="24" cy="34" r="2" fill="#818181" />
                                </svg>
                                <span className='article-title' style={{ marginTop: '18px', color: '#37428E', fontWeight: 600, fontSize: '22px' }}>
                                    Nenhum artigo encontrado
                                </span>
                                <span style={{ fontSize: '16px', color: '#818181', marginTop: '8px', textAlign: 'center', maxWidth: '400px' }}>
                                    O artigo que você procura não foi encontrado.<br />
                                    Verifique o link ou tente novamente mais tarde.
                                </span>
                                <Link to="/article" style={{ marginTop: '22px', textDecoration: 'none' }}>
                                    <button
                                        style={{
                                            background: '#4654A3',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '8px',
                                            padding: '10px 24px',
                                            fontSize: '16px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Ver todos os artigos
                                    </button>
                                </Link>
                            </div>

                    )}


                </div>
                {false && (
                    <NewsletterSignup
                        name={name}
                        email={email}
                        onChange={this.handlerChange}
                        onSubmit={() => console.log('Cadastrar newsletter')}
                    />
                )}

                <Footer />
            </div>
        );
    }
}

export default ArticleDetail;
